// eslint-disable-next-line import/prefer-default-export
export const getBettingStatus = (isLoggedIn, displayBettingLinks, canBet) => {
    if (isLoggedIn) {
        return displayBettingLinks && canBet;
    }
    return displayBettingLinks;
};
